import { axios } from 'api'
import ClassFinder from 'components_v1/pageLevelComponents/classFinder/ClassFinder'
import { useCommonEntryContext } from 'components_v2/common'
import { useMeta, useTitle } from 'hooks/useMetaTitle'
import React, { useEffect, useState } from 'react'

const ClassFinderView = () => {
  const [props, setProps] = useState(null)
  const { globalState, setGlobalState } = useCommonEntryContext()
  const classFinderData = globalState?.class_finder_data
  useEffect(() => {
    if (classFinderData) {
      setProps(classFinderData)
      return
    }
    axios
      .get('/plan_entries/class_finder/data', { load: true })
      .then((res) => {
        setProps(res.data)
        setGlobalState('class_finder_data', res.data)
      })
      .catch((err) => console.log(err))
  }, [classFinderData, setGlobalState])
  useTitle('Class Finder - Yoga, Fitness, Mindfulness')
  useMeta([
    {
      name: 'description',
      content:
        'Find the perfect class for you on ALO Wellness Club using our filters that allow you to search by duration, instructors, styles, difficulty, intensity, and more.'
    }
  ])
  const params = new URLSearchParams(window.location.search)

  const filteredStyles = params?.get('styles') || ''
  const filteredInstructors = params?.get('instructors') || ''
  const filteredFocusArea = params?.get('focus_areas') || ''
  const filteredDifficulties = params?.get('difficulties') || ''
  const filteredIntensities = params?.get('intensities') || ''
  const filteredEquipment = params?.get('equipment') || ''
  const defaultOrder = params?.get('order') || 'date'
  const excludeCompleted = params?.get('excludeCompleted') || null

  if (!props) return null
  return (
    <>
      <div className='grey-cover-header'>
        <div className='grey-centered-content'>
          <h1>Class Finder</h1>
          <p className='lead'>
            Find the perfect workout or wellness class to match your mood.
          </p>
        </div>
      </div>
      <div className='section-container.class-scroll-to'>
        <div className='new-explore.explore-cold-start'>
          <div className='single-class-container'>
            <ClassFinder
              autopaginate={true}
              baseUrl={`/class-finder`}
              disableStickyFilter={true}
              defaultOrder={defaultOrder}
              filteredInstructors={filteredInstructors}
              filteredStyles={filteredStyles}
              filteredDifficulties={filteredDifficulties}
              filteredIntensities={filteredIntensities}
              filteredEquipment={filteredEquipment}
              filteredFocusArea={filteredFocusArea}
              excludeCompleted={excludeCompleted}
              {...props}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ClassFinderView
